'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');
var styled = require('styled-components');
var browser_utils = require('../../browser.utils-bfcc05c6.js');
require('../../viewport.utils-0c2b4e2b.js');
var EnergyEfficiencyBadge = require('../../EnergyEfficiencyBadge-6ac9b005.js');
var Badges = require('../../Badges-9563646b.js');
var types = require('../../types-169d4b99.js');
var WishlistIconButton_index = require('../../WishlistIconButton/index.js');
var ProductTile_ProductTileInfoBox_index = require('../ProductTileInfoBox/index.js');
require('../../typography/index.js');
require('../../Icons/Svgs/SaleBadgeIcon/index.js');
require('../../EnergyEfficiencyGrades/index.js');
require('../../Icons/WishlistIcon/index.js');
require('../../Product.styles-8bd9554e.js');
require('../../Product/ProductImage/index.js');
require('../../Product/ProductInfoBox/index.js');
require('../../Product/PriceRenderer/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Label;
(function (Label) {
    Label[Label["SOLD_OUT"] = 0] = "SOLD_OUT";
    Label[Label["ON_SALE"] = 1] = "ON_SALE";
    Label[Label["NEW"] = 2] = "NEW";
    Label[Label["SUSTAINABLE"] = 3] = "SUSTAINABLE";
    Label[Label["NONE"] = 4] = "NONE";
})(Label || (Label = {}));
var useLabelBadge = function (_a) {
    var isOnSale = _a.isOnSale, showMoodImage = _a.showMoodImage, hideNewBadge = _a.hideNewBadge, isSpecialSalesEventProduct = _a.isSpecialSalesEventProduct, isSpecialSalesEventActive = _a.isSpecialSalesEventActive, _b = _a.product, soldOut = _b.soldOut, isSustainable = _b.isSustainable, isNew = _b.isNew;
    if (showMoodImage) {
        return Label.NONE;
    }
    if (soldOut && isSpecialSalesEventProduct) {
        return Label.SOLD_OUT;
    }
    if (isOnSale && !isSpecialSalesEventActive) {
        return Label.ON_SALE;
    }
    if (!hideNewBadge && isNew) {
        return Label.NEW;
    }
    if (isSustainable) {
        return Label.SUSTAINABLE;
    }
    return Label.NONE;
};
var LabelBadge = function (_a) {
    var label = _a.label, translator = _a.translator;
    if (label === Label.SOLD_OUT) {
        return (React__default['default'].createElement(EnergyEfficiencyBadge.TextBadgeWrapper, null,
            React__default['default'].createElement(EnergyEfficiencyBadge.SoldOutBadge, null, translator(EnergyEfficiencyBadge.SOLD_OUT_LABEL))));
    }
    if (label === Label.ON_SALE) {
        return (React__default['default'].createElement(EnergyEfficiencyBadge.TextBadgeWrapper, null,
            React__default['default'].createElement(EnergyEfficiencyBadge.StyledSalesBadge, null, translator(EnergyEfficiencyBadge.SALE_LABEL))));
    }
    if (label === Label.NEW) {
        return (React__default['default'].createElement(EnergyEfficiencyBadge.TextBadgeWrapper, null,
            React__default['default'].createElement(EnergyEfficiencyBadge.NewProductBadge, null, translator(EnergyEfficiencyBadge.NEW_LABEL))));
    }
    if (label === Label.SUSTAINABLE) {
        return (React__default['default'].createElement(EnergyEfficiencyBadge.TextBadgeWrapper, null,
            React__default['default'].createElement(EnergyEfficiencyBadge.StyledSustainabilityBadge, null, translator(EnergyEfficiencyBadge.SUSTAINABILITY_LABEL))));
    }
    return null;
};

var ProductBadgesGrid = styled__default['default'](Badges.BadgesGrid).withConfig({ displayName: "ww-uikit_ProductBadgesGrid_loy4z79h", componentId: "sc-7jjexg" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    grid-column: 1/4;\n    grid-row: 1/3;\n    width: 100%;\n    height: 100%;\n    padding-bottom: 0;\n    position: relative;\n    grid-template:\n        '", "       .                       ", "' auto\n        '.                          .                       .                    ' 1fr\n        '", "        ", "     ", "  ' 60px\n        '", "    .                       ", "' auto\n        / auto 1fr auto;\n    ", "\n    ", "\n    ", "\n"], ["\n    grid-column: 1/4;\n    grid-row: 1/3;\n    width: 100%;\n    height: 100%;\n    padding-bottom: 0;\n    position: relative;\n    grid-template:\n        '", "       .                       ", "' auto\n        '.                          .                       .                    ' 1fr\n        '", "        ", "     ", "  ' 60px\n        '", "    .                       ", "' auto\n        / auto 1fr auto;\n    ",
    "\n    ",
    "\n    ",
    "\n"])), Badges.Positions.topleft, Badges.Positions.topright, Badges.Positions.center, Badges.Positions.center, Badges.Positions.center, Badges.Positions.bottomleft, Badges.Positions.bottomright, browser_utils.forIE(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n        -ms-grid-row : 1;\n        -ms-grid-row-span : 2;\n        -ms-grid-column : 1;\n        -ms-grid-column-span : 3;\n    "], ["\n        -ms-grid-row : 1;\n        -ms-grid-row-span : 2;\n        -ms-grid-column : 1;\n        -ms-grid-column-span : 3;\n    "]))), function (_a) {
    var $size = _a.$size;
    return $size === 'small' &&
        "\n            padding-left: 0px;\n            margin-left: -3px;\n    ";
}, function (_a) {
    var $isNewVersion = _a.$isNewVersion;
    return $isNewVersion &&
        "\n            padding-bottom: 10px;\n    ";
});
var StyledWishlistIconButton = styled__default['default'](WishlistIconButton_index['default']).withConfig({ displayName: "ww-uikit_StyledWishlistIconButton_loy4z79h", componentId: "sc-uoow0r" })(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    margin-bottom: auto;\n"], ["\n    margin-bottom: auto;\n"])));
var shouldShowSaleBadge = function (product, featureToggles, saleOnlyWhenStrikethrough) {
    if (saleOnlyWhenStrikethrough && product.price === product.originalPrice) {
        return false;
    }
    if (featureToggles) {
        var isBlackFriday = product.blackFriday && featureToggles.isBlackFridayActive;
        var isCyberMonday = product.cyberMonday && featureToggles.isCyberMondayActive;
        return (isBlackFriday || isCyberMonday) && featureToggles.isSpecialSalesEnabled;
    }
    return false;
};
var ProductTileBadges = function (_a) {
    var product = _a.product, badgeConfigs = _a.badgeConfigs, featureToggles = _a.featureToggles, configurations = _a.configurations, variantsComponent = _a.variantsComponent, _b = _a.isNewVersion, isNewVersion = _b === void 0 ? false : _b, _c = _a.saleOnlyWhenStrikethrough, saleOnlyWhenStrikethrough = _c === void 0 ? false : _c, imageConfigs = _a.imageConfigs, hideNewBadge = _a.hideNewBadge, _d = _a.forSingleLookPromotion, forSingleLookPromotion = _d === void 0 ? false : _d, translator = _a.translator;
    var handleWishlistStateChange = badgeConfigs.handleWishlistStateChange, _e = badgeConfigs.isInWishlist, isInWishlist = _e === void 0 ? false : _e, _f = badgeConfigs.size, size = _f === void 0 ? 'default' : _f;
    var isImageServiceProductImageEnabled = configurations.isImageServiceProductImageEnabled, quantityBadgePosition = configurations.quantityBadgePosition, specialSales = configurations.specialSales;
    var hasVariant = !!variantsComponent;
    var showSalesBadge = shouldShowSaleBadge(product, featureToggles, saleOnlyWhenStrikethrough);
    var priceState = ProductTile_ProductTileInfoBox_index.determinePriceState(product);
    var isBlackFriday = product.blackFriday && featureToggles.isBlackFridayActive;
    var isCyberMonday = product.cyberMonday && featureToggles.isCyberMondayActive;
    var isSpecialSalesEventActive = featureToggles.isBlackFridayActive || featureToggles.isCyberMondayActive;
    var isSpecialSalesEventProduct = isBlackFriday || isCyberMonday;
    var labelBadge = useLabelBadge({
        isOnSale: priceState !== ProductTile_ProductTileInfoBox_index.PriceState.NO_SALE,
        showMoodImage: imageConfigs.showMoodImage,
        hideNewBadge: hideNewBadge,
        isSpecialSalesEventProduct: isSpecialSalesEventProduct,
        isSpecialSalesEventActive: isSpecialSalesEventActive,
        product: product,
    });
    var defaultBadgeSlots = {
        bottomleft: [],
        bottomright: [],
        topleft: [],
        topright: [],
        center: [],
    };
    if (handleWishlistStateChange) {
        defaultBadgeSlots[Badges.Positions.topright].push(React__default['default'].createElement(StyledWishlistIconButton, { key: "wishlist-badge", onClick: function (e) { return handleWishlistStateChange(e, !isInWishlist, product); }, isSelected: isInWishlist || product.isInWishlist }));
    }
    if (labelBadge !== Label.NONE) {
        defaultBadgeSlots[Badges.Positions.bottomleft].push(React__default['default'].createElement(LabelBadge, { key: "label-badge", label: labelBadge, translator: translator }));
    }
    if (hasVariant) {
        defaultBadgeSlots[Badges.Positions.center].push(variantsComponent);
    }
    if (showSalesBadge) {
        var productSalesType = types.ProductSalesType.NO_SALES;
        if (isBlackFriday) {
            productSalesType = types.ProductSalesType.BLACK_FRIDAY;
        }
        else if (isCyberMonday) {
            productSalesType = types.ProductSalesType.CYBER_MONDAY;
        }
        var colours = {
            BLACK_FRIDAY: (specialSales === null || specialSales === void 0 ? void 0 : specialSales.blackFridayBadgeColor) || '',
            CYBER_MONDAY: (specialSales === null || specialSales === void 0 ? void 0 : specialSales.cyberMondayBadgeColor) || '',
            NO_SALES: '',
        };
        defaultBadgeSlots[Badges.Positions.topleft].push(React__default['default'].createElement(EnergyEfficiencyBadge.SaleBadge, { key: "sale-badge", "data-testid": "sale-badge", color: colours[productSalesType || 'NO_SALES'], "data-sales-type": productSalesType, size: size, forNewVersion: isNewVersion }));
    }
    if (isImageServiceProductImageEnabled && product.quantityBadge > 0) {
        defaultBadgeSlots[quantityBadgePosition || Badges.Positions.topleft].push(React__default['default'].createElement(EnergyEfficiencyBadge.ProductQuantityBadge, { key: "quantity-badge", "data-testid": "quantity-badge", quantity: product.quantityBadge, size: size }));
    }
    return (React__default['default'].createElement(ProductBadgesGrid, { "$size": size, "$isNewVersion": isNewVersion, hasVariant: hasVariant },
        defaultBadgeSlots[Badges.Positions.topleft].length > 0 && (React__default['default'].createElement(Badges.BadgesTopLeft, { "$isNewVersion": isNewVersion, id: "top-left" }, defaultBadgeSlots[Badges.Positions.topleft])),
        defaultBadgeSlots[Badges.Positions.topright].length > 0 && (React__default['default'].createElement(Badges.BadgesTopRight, { "$isNewVersion": isNewVersion, id: "top-right" }, defaultBadgeSlots[Badges.Positions.topright])),
        defaultBadgeSlots[Badges.Positions.center].length > 0 && (React__default['default'].createElement(Badges.BadgesCenter, { id: "center" }, defaultBadgeSlots[Badges.Positions.center])),
        defaultBadgeSlots[Badges.Positions.bottomleft].length > 0 && (React__default['default'].createElement(Badges.BadgesBottomLeft, { "$isNewVersion": isNewVersion, "$forSingleLookPromotion": forSingleLookPromotion, id: "bottom-left" }, defaultBadgeSlots[Badges.Positions.bottomleft])),
        defaultBadgeSlots[Badges.Positions.bottomright].length > 0 && (React__default['default'].createElement(Badges.BadgesBottomRight, { "$isNewVersion": isNewVersion, id: "bottom-right" }, defaultBadgeSlots[Badges.Positions.bottomright]))));
};
var templateObject_1, templateObject_2, templateObject_3;

exports.ProductTileBadges = ProductTileBadges;
//# sourceMappingURL=index.js.map
